import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Footer } from './components/Footer';
import { MainMenu } from './MainMenu';

export const AppWrapper = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <MainMenu />
      <Box
        sx={{
          mt: 0.5,
          flex: 1,
          overflow: 'auto',
          pt: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          pb: 10,
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};
